import React, { useEffect } from 'react';
import moment from 'moment';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';

const CommonYearPicker = ({
  years,
  setYears,
  yearOptionsOrder = 'desc', //anyOneOf['asce','desc']
  addYears = 10,
  baseYear = 2000,
  selectcurrentYear = false,
  selectBaseYear = false
}) => {
  let currentYear = parseInt(moment().format('YYYY'));
  let yearOrder = yearOptionsOrder;

  function getYearOptions() {
    let yearOptions = [];
    if (selectBaseYear) {
      let year = baseYear;
      while (year <= baseYear + addYears) {
        yearOptions.push({
          value: String(year),
          label: year
        });
        year++;
      }
    } else if (selectcurrentYear) {
      let year = currentYear;
      while (year <= currentYear + addYears) {
        yearOptions.push({
          value: String(year),
          label: year
        });
        year++;
      }
    }
    if (!yearOrder) return yearOptions.reverse();
    return yearOptions;
  }
  useEffect(() => {
    if (!years?.value && setYears)
      setYears({
        value: '',
        label: 'Choose Year'
      });
  }, [years?.label]);

  return (
    <CommonSelect sort={true}
      name="year"
      value={years}
      onChange={e => {
        setYears(e);
      }}
      options={[
        {
          label: 'Choose Year',
          value: ''
        },
        ...getYearOptions()
      ]}
      dropdownStyle={{
        top: '40px',
        fontSize: '16px'
      }}
      stylesContainer={{
        height: '40px',
        width: '225px',
        marginRight: '20px'
      }}
      styleText={{
        fontSize: '14px',
        padding: '0 20px'
      }}
    />
  );
};
export default CommonYearPicker;
